<template>
  <div class="homepage-schemes q-mb-md">
    <div class="schemes-list-container">
      <q-list>
        <q-item-label header class="header">{{ title }}</q-item-label>

        <q-item v-for="scheme in schemesProp" :key="scheme.id">
          <q-item-section avatar class="date">
            <q-item-label caption v-if="title == 'Nieuwste regelingen'">{{
              formatDate(scheme.createdDate)
            }}</q-item-label>
            <q-item-label caption v-else-if="title == 'Komende deadlines'">{{
              formatDate(scheme.currentDeadline)
            }}</q-item-label>
          </q-item-section>
          <q-item-section class="title">
            <q-item-label>
              <router-link
                style="text-decoration: none"
                :to="{ name: 'GrantDetails', params: { grantId: scheme.id } }"
                v-bind:target="openDetailsInNewTab ? '_blank' : null"
              >
                <span class="title"> {{ scheme.name }} </span>
              </router-link></q-item-label
            >
          </q-item-section>
        </q-item>
      </q-list>
    </div>

    <div class="more-btn-container">
      <router-link
        v-if="title == 'Komende deadlines'"
        style="text-decoration: none"
        :to="{ name: 'DeadlinesSchemes' }"
        v-bind:target="openDetailsInNewTab ? '_blank' : null"
      >
        <q-btn class="see-more-btn" outline>
          Meer <i class="las la-2x la-arrow-right"></i>
        </q-btn>
      </router-link>

      <router-link
        v-else
        style="text-decoration: none"
        :to="{ name: 'NewestSchemes' }"
        v-bind:target="openDetailsInNewTab ? '_blank' : null"
      >
        <q-btn class="see-more-btn" outline>
          Meer <i class="las la-2x la-arrow-right"></i>
        </q-btn>
      </router-link>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import moment from 'moment';
import store from '../../store/index';
export default {
  props: {
    schemesProp: Array,
    title: String,
  },
  setup(props) {
    const schemes = ref(props.schemesProp);

    const formatDate = (date) => {
      return moment(date).format('DD-MM-YYYY');
    };

    const openDetailsInNewTab = computed({
      get: () => store.state.user.openDetailsInNewTab,
    });

    return {
      formatDate,
      schemes,
      openDetailsInNewTab,
    };
  },
};
</script>
